module.exports = __webpack_public_path__ + "static/img/Fran-Karacic.1088367.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Fran-Karacic.jpg
// module id = 0Mbn
// module chunks = 0